import { Component, Input, OnInit, WritableSignal, signal } from "@angular/core";
import { NotificationService } from "../services/notification-service";
import { RapportService } from "../services/rapport-service";
import { MessageService } from "primeng/api";

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

    @Input({ required: true }) message: any;

    progress: WritableSignal<number> = signal(0);
    success: WritableSignal<boolean> = signal(false);

    constructor(private notificationService: NotificationService,
        private rapportService: RapportService,
        public messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.message.detail.upload.progress.subscribe(progress => {
            this.progress.set(progress.progress);
            this.success.set(progress.success);
            if (progress.success === true) {
                setTimeout(() => {
                    this.closeUpload();
                }, 10000);
            }
        }); 
    }

    getIconClass(severity: string): string {
        switch (severity) {
            case 'success': return 'pi-check-circle';
            case 'error': return 'pi-times-circle';
            case 'warn': return 'pi-exclamation-triangle';
            case 'info': return 'pi-info-circle';
            default: return 'pi-info-circle';
        } 
    }

    closeUpload() {
        this.messageService.clear('notification');
    }

    reload() {
        window.location.reload();
    }

    applyUpdate() {
        if (this.message?.detail?.onReload) {
            this.message.detail.onReload();
        }
    }

    openUrl(url: string) {
        window.open(url, '_blank');
    }

    getViewUrl(): string | null {
        return this.rapportService.resolveNotificationViewUrl(this.message?.data);
    }
}